import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
const DescriptionMapper = ({ addBreaks = false, data, keyPrefix, }) => {
    const keys = useMemo(() => (data.map(() => `${keyPrefix}_item_${uuidv4()}`)), [data, keyPrefix]);
    return (_jsx(_Fragment, { children: data.map((item, index) => (_jsxs(Fragment, { children: [item, addBreaks && index < data.length - 1 && _jsx("br", {}, void 0)] }, keys[index]))) }, void 0));
};
export default DescriptionMapper;
